<template>
    <b-container>
        <b-row align-v="center" align-h="center" class=" mx-0" style="width:100%;margin-bottom: 56px;">
            <Spinner
            :offline="this.error"
            :loading="this.history.length === 0 && this.fetching"
            @retry-action="reFetch()"
            />
            <b-card class="w-100 mt-3" v-if="this.userInfo.admin===1||true" bg-variant="light">
              <b-card-title>搜索</b-card-title>
              <b-card-text>
                <b-form-input class="mb-3" v-model="searchCid" placeholder="卡号"></b-form-input>
                <b-form-input v-if="this.userInfo.admin===1" class="mb-3" v-model="searchName" placeholder="姓名"></b-form-input>
                <b-calendar v-if="this.fuzzysearch" block class="mb-3" v-model="searchDate" @context="onContext" locale="zh-CN"></b-calendar>
                <b-form-group class="text-center">
                  <b-form-radio-group id="radio-group-2" v-model="type" name="radio-sub-component">
                    <b-form-radio value="transaction">交易历史</b-form-radio>
                    <b-form-radio value="loan">贷款</b-form-radio>
                    <!-- <b-form-radio value="overdraft">透支</b-form-radio> -->
                  </b-form-radio-group>
                </b-form-group>
              </b-card-text>
              <b-button block :variant="(this.fuzzysearch)?'success':'secondary'" @click="fuzzysearch=!fuzzysearch">模糊搜索({{(this.fuzzysearch)?'已开启':'已关闭'}})</b-button>
              <b-button block variant="primary" @click="searchDB()">确定</b-button>
            </b-card>
            <!-- <Timeline
            v-for="(mission,index) in history"
            :date="mission.date"
            :content="mission.content"
            :title="mission.title"
            :key="mission.uuid"
            :first="index === 0"
            :last="index === history.length - 1"
            :variant="mission.variant"
            /> -->
            <Timeline
            v-for="(result,index) in results"
            :date="result.date"
            :content="result.content"
            :title="result.title"
            :key="result.key"
            :first="index === 0"
            :last="index === results.length-1"
            :variant="result.variant"
            />
        </b-row>
    </b-container>
</template>

<style>

</style>

<script>
import Spinner from '../components/LoadingSpinner.vue'
import Timeline from '../components/Timeline.vue'
import {auth} from '../components/auth'
import {urls} from '../components/urls'

export default {
    name:'rank',
    components:{
        Spinner,
        Timeline
    },
    mixins: [auth,urls],
    data:function(){
        return{
            error:false,
            fetching:true,
            disableBtn:false,
            type:'',
            searchCid:'',
            searchName:'',
            searchDate:'',
            context: null,
            fuzzysearch:false,
            history:[
                {date:'12121',title:'success',content:'asfafafaffa',variant:'success'},
                {date:'12121',title:'danger',content:'asfafafaffa',variant:'danger'},
                {date:'12121',title:'warning',content:'asfafafaffa',variant:'warning'},
                {date:'12121',title:'primary',content:'asfafafaffa',variant:'primary'},
                {date:'12121',title:'light',content:'asfafafaffa',variant:'light'},
            ],
            results:[]
        }
    },
    methods: {
      reFetch:function(){
        alert('reFetch');
      },
      timeStamp2String:function(time){
        const datetime = new Date(time);
        // console.log(datetime)
        let res="";
        const month = (datetime.getMonth()+1).toString();
        res=month+".";
        const day = (datetime.getDate()).toString();
        if(datetime.length===1)res+="0";
        res+=day+" ";
        const hour = (datetime.getHours()).toString();
        res+=hour+":";
        let minute = (datetime.getMinutes()).toString();
        if(minute.length===1)res+="0";
        res+=minute;
        return res;
      },
      c2v:function(codename){
        switch(codename){
          case "deposit":
            return "success";
          case "withdraw":
            return "warning";
          case "transfer out":
            return "warning";
          case "transfer in":
            return "success";
          case "pay loan":
            return "warning";
          case "loan":
            return "warning";
          default:
            return "default";
        }
      },
      onContext:function(ctx) {
        this.context = ctx
      },
      searchDB:function(){
        if(this.searchCid.trim()===""&&this.searchName.trim()===""&&this.searchDate.trim()===""){
          this.$bvToast.toast("无法搜索，请检查你的输入", {
            title: `错误`,
            toaster: 'b-toaster-bottom-center',
            variant: 'danger',
            solid: true,
            appendToast: true
          })
          return 1;
        }
        let url="";
        switch(this.type){
          case "transaction":
            url="transaction"
            break
          case "loan":
            url="loan"
            break
          case "overdraft":
            url="overdraft"
            break
          default:
            this.$bvToast.toast("未知类型，请检查你的选择", {
              title: `错误`,
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true,
              appendToast: true
            })
            return 1
        }
        this.$axios.get(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/record",{
          headers: { "Authorization" : this.header},
          params: { 
            type: this.type,
            fuzzy:this.fuzzysearch,
            cid:this.searchCid,
            name:this.searchName,
            date:this.searchDate
          } 
        })
        .then(res=>{
          this.error=false;
          this.fetching=false;
          this.results=res.data.map(obj=>{
            return {
              title:obj.title,
              date:this.timeStamp2String(obj.date),
              content:`卡号：${obj.cid}\n金额:${obj.amount}￥`,
              key:obj.key,
              variant:this.c2v(obj.title)
            }
          });
          if(res.data.length===0){
            this.$bvToast.toast("没有搜索到结果", {
              title: `提示`,
              toaster: 'b-toaster-bottom-center',
              variant: 'warning',
              solid: true,
              appendToast: true
            })
          }
          console.log(res.data);
        })
        .catch(error => {
          this.error=true;
          this.fetching=false;
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        }); 
        return 0
      },
    },
    computed:{

    }
}
</script>

